import { cn } from '@mdvip/shared/lib/utils';
import { useLocale } from '@mdvip/shared/stores/userPreferencesStore';
import { BlankValue } from './BlankValue';

/** Past this many days a balance is flagged. */
const OVERDUE_THRESHOLD_DAYS = 60;

export interface DaysPastDueCellProps {
  days: number | null;
}

/** The Days past due column: the count in the reader's locale, flagged once it's past 60 days. */
export function DaysPastDueCell({ days }: DaysPastDueCellProps) {
  const locale = useLocale();
  if (days === null) return <BlankValue />;

  return (
    <span className={cn('tabular-nums', days > OVERDUE_THRESHOLD_DAYS && 'font-semibold text-destructive-foreground')}>
      {new Intl.NumberFormat(locale).format(days)}
    </span>
  );
}
